<template>
  <div class="write-container">
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i
          class="el-icon-arrow-left back-icon"
          style="font-size: 20px;font-weight: 600;"
        />
      </div>
      <div class="nav-title">{{ pageTitle }}</div>
      <div class="nav-actions">
        <!-- 保留空位，与左侧返回按钮平衡 -->
      </div>
    </div>
    <div class="content-page">
      <div class="content-title">{{ cardTitle }}</div>
      <img src="../../assets/video/sc.png" alt="" class="content-sc" />
    </div>
    <div class="content-img">
      <img
        src="../../assets/video/fa.png"
        alt=""
        class="content-img"
        v-if="pageTitle == '工作'"
      />
      <img
        src="../../assets/video/zy.png"
        alt=""
        class="content-img"
        v-if="pageTitle == '学习'"
      />
    </div>
    <div class="content-texts">
      <img src="../../assets/video/sz.png" alt="" class="conten-img" />
      <div class="content-text">Hello : )</div>
    </div>
    <div
      style="font-size: 20px; font-weight: 500;  color: #6A8EAC; text-align: left;padding: 0 20px;"
    >
      请输入您的需求
    </div>
    <div class="input-box">
      <input
        type="text"
        placeholder="请输入您的需求"
        v-model="inputText"
        @keyup.enter="submitInput"
        style="flex: 1;"
      />
      <div class="send-btn" @click="submitInput">
        <i class="el-icon-top"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageTitle: "",
      cardTitle: "",
      href: "",
      inputText: "",
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    initPage() {
      const source = this.$route.query.source;
      const cardTitle = this.$route.query.cardTitle;
      this.href = this.$route.query.href;
      this.cardTitle = cardTitle;
      if (source == "work") {
        this.pageTitle = "工作";
      } else {
        this.pageTitle = "学习";
      }
    },
    submitInput() {
      if (!this.inputText.trim()) {
        this.$message.warning("请输入您的需求");
        return;
      }
      const source = this.$route.query.source;

      console.log(source, "----83----");
      this.$router.push({
        path: "/writeDetail",
        query: {
          href: this.href,
          cardTitle: this.cardTitle,
          source: source,
          inputText: this.inputText,
          title: source == "work" ? "工作" : "学习",
        },
      });
    },
  },
  created() {
    this.initPage();
  },
};
</script>
<style>
.write-container {
  padding: 5px 0px 10px 0px;
  background-image: url("../../assets/video/bg.png");
  height: 100vh;
  background-size: cover;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  /* background-color: #ffffff; */
  /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05); */
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-icon {
  width: 20px;
  height: 20px;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.nav-actions {
  width: 40px;
}

.content-page {
  padding: 20px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
}
.content-title {
  flex: 1;
  margin-left: 20px;
}
.content-sc {
  width: 24px;
  height: 24px;
}
.content-texts {
  display: flex;
  align-items: center;
  /* margin-top: 20px; */
  padding: 20px;
}
.conten-img {
  width: 30px;
  height: 30px;
}
.content-text {
  /* font-size: 16px; */
  font-weight: 400;
  color: #303133;
  margin-left: 10px;
  font-family: AlibabaPuHuiTi_2_75_SemiBold;
  font-size: 24px;
  color: #072b60;
  line-height: 66rpx;
  text-align: left;
  font-style: normal;
}
.input-box {
  width: 90%;
  height: 70px;
  background: #ffffff;
  box-shadow: 0rpx 4px 28px 0rpx rgba(0, 0, 0, 0.15);
  border-radius: 22px;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  line-height: 70px;
  font-size: 20px;
  padding: 0 20px;
  text-align: left;
  display: flex;
  align-items: center;
}
.send-btn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: linear-gradient(90deg, #5ca3f6 0%, rgba(92, 179, 246, 0.8) 100%);
  border-radius: 9px;
  color: #ffffff;
}
</style>
